import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import sanitizeHtml from "sanitize-html";
import Select from "react-select";

// Components
import Loader from "../../utils/Loader";
import MerchantSettingsFieldsPaypal from "./MerchantSettingsFieldsPaypal";
import MerchantSettingsFieldsMoneris from "./MerchantSettingsFieldsMoneris";
import Button from "../../modal/Button";
import Modal from "../../modal/Modal";

// CSS
import "../../../css/react-select.css";

// State
import { addRoute } from "../../../store/actions/route";
import { setpageTitle } from "../../../store/actions/siteInfo";
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

class AdminMerchantSettings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			data: {},
			initial: {},
			merchants: [],
			initialMerchant: null,
			currentMerchant: null,
			error: "",
			showModal: false,

			updateLoading: false,
			updateSuccess: "",
			updateErrors: {},

			fieldsSaving: [],
			fieldsErrored: {},
			fieldsSuccess: {}
		};

		this.props.addRoute(this.props.match);
		this.props.setpageTitle("Merchant Settings");
	}

	componentDidMount() {
		this.loadData();
	}

	loadData() {
		const { cart, user } = this.props;

		const token = user.token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.get(REACT_APP_API_URL + "merchants/" + cart.id, { headers: AUTH_HEADER })
			.then(response => {
				if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({ isLoading: false, error: response.data.message });
				} else {
					this.setState({
						isLoading: false,
						merchants: response.data.merchant_types,
						data: response.data.merchant,
						initial: response.data.merchant,
						initialMerchant: !!response.data.merchant.id
							? response.data.merchant.id
							: null,
						currentMerchant: !!response.data.merchant.id
							? response.data.merchant.id
							: null
					});
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						isLoading: false,
						error: err.response.data.errors
							? err.response.data.errors
							: err.response.data.message
					});
				} else {
					this.setState({ isLoading: false, error: err.message });
				}
			});
	}

	// ===================================================================================
	//  MERCHANT UPDATE
	// ===================================================================================
	handleMerchantInputUpdate(event) {
		event.preventDefault();
		this.setState({
			data: {
				...this.state.data,
				[event.target.id]: event.target.value
			}
		});
	}

	handleFieldSave(id) {
		const { user } = this.props;

		this.setState(
			{
				fieldsSaving: this.state.fieldsSaving.concat(id),
				fieldsErrored: omit(this.state.fieldsErrored, id),
				fieldsSuccess: omit(this.state.fieldsSuccess, id)
			},
			() => {
				const savingArrayIndex = this.state.fieldsSaving.indexOf(id);
				const value = this.state.data[id];
				const data = {
					[id]: value
				};

				const token = user.token;
				const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
				return axios
					.post(REACT_APP_API_URL + "merchants/field", data, { headers: AUTH_HEADER })
					.then(response => {
						if (response.data.status === 403) {
							this.props.userLogout("admin");
						} else if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({
								fieldsSaving: this.state.fieldsSaving.filter(
									(_, i) => i !== savingArrayIndex
								),
								fieldsErrored: {
									...this.state.fieldsErrored,
									[id]: !isEmpty(response.data.errors)
										? response.data.errors
										: response.data.message
								},
								initial: {
									...this.state.initial,
									[id]: value
								}
							});
						} else {
							this.setState({
								fieldsSaving: this.state.fieldsSaving.filter(
									(_, i) => i !== savingArrayIndex
								),
								fieldsSuccess: {
									...this.state.fieldsSuccess,
									[id]: response.data.message
								}
							});

							this.props.userTokenUpdate("admin", response.data.token);
						}
					})
					.catch(err => {
						if (err.response) {
							this.setState({
								fieldsSaving: this.state.fieldsSaving.filter(
									(_, i) => i !== savingArrayIndex
								),
								fieldsErrored: {
									...this.state.fieldsErrored,
									[id]: err.response.data.error
										? err.response.data.error
										: err.response.data.message
								}
							});
						} else {
							this.setState({
								fieldsSaving: this.state.fieldsSaving.filter(
									(_, i) => i !== savingArrayIndex
								),
								fieldsErrored: {
									...this.state.fieldsErrored,
									[id]: err.message
								}
							});
						}
					});
			}
		);
	}

	updateSelectedMerchant(item) {
		this.setState({
			currentMerchant: item.id
		});
	}

	submitMerchantChange() {
		this.setState({
			showModal: true
		});
	}

	handleMerchantUpdate() {
		const { user } = this.props;

		this.setState({
			updateSuccess: "",
			updateErrors: {},
			updateLoading: true
		});

		const data = {
			merchant: this.state.currentMerchant
		};

		const token = user.token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.post(REACT_APP_API_URL + "merchants/set", data, { headers: AUTH_HEADER })
			.then(response => {
				if (response.data.status === 403) {
					this.props.userLogout("admin");
				} else if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: { general: response.data.message }
					});
				} else {
					this.setState({
						updateLoading: false,
						updateSuccess: response.data.message
					});

					this.props
						.userTokenUpdate("admin", response.data.token)
						.then(() => this.loadData());
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						updateLoading: false,
						updateErrors: {
							general: err.response.data.error
								? err.response.data.error
								: err.response.data.message
						}
					});
				} else {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.message }
					});
				}
			});
	}

	render() {
		const {
			error,
			isLoading,
			updateSuccess,
			updateErrors,
			merchants,
			data,
			initialMerchant,
			currentMerchant
		} = this.state;

		let merchantComponent = null;

		if (data.id === "PAYPAL") {
			merchantComponent = (
				<MerchantSettingsFieldsPaypal
					merchant={this.state.data}
					initialMerchantValues={this.state.initial}
					fieldsSaving={this.state.fieldsSaving}
					fieldsErrored={this.state.fieldsErrored}
					fieldsSuccess={this.state.fieldsSuccess}
					handleFieldSave={this.handleFieldSave.bind(this)}
					handleMerchantInputUpdate={this.handleMerchantInputUpdate.bind(this)}
				/>
			);
		} else if (data.id === "MONERIS") {
			merchantComponent = (
				<MerchantSettingsFieldsMoneris
					merchant={this.state.data}
					initialMerchantValues={this.state.initial}
					fieldsSaving={this.state.fieldsSaving}
					fieldsErrored={this.state.fieldsErrored}
					fieldsSuccess={this.state.fieldsSuccess}
					handleFieldSave={this.handleFieldSave.bind(this)}
					handleMerchantInputUpdate={this.handleMerchantInputUpdate.bind(this)}
				/>
			);
		} else {
			merchantComponent = (
				<div className="fieldset">
					<label className="title-label">Merchant Information:</label>

					<div className="error">Unable to find your merchant record.</div>
				</div>
			);
		}

		return (
			<div>
				<h1>Merchant Settings</h1>

				{/* Has error */}
				{error ? (
					<div className="error">
						{Object.keys(error).map(key => (
							<span key={key}>{error[key]}</span>
						))}
					</div>
				) : // No error
				// Loading
				isLoading ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					// Show form
					<div>
						{updateSuccess && (
							<div className="success msg_animate">{updateSuccess}</div>
						)}

						<div className="fieldset">
							<div className="instruction">
								<label>Caution:</label>
								<br />
								The following is for use only within the cart. Do not distribute any
								information given to you by your merchant.
								<br />
								Please enter all merchant information EXACTLY as it was given to you
								by your merchant.
								<br />
								Please do not use personal credit information for any cart settings
								seen here!
							</div>

							<div className="floated-field-container">
								<div className="form-field half-field">
									<label htmlFor="country">Merchant:</label>

									{!!updateErrors.merchant && (
										<div className="error msg_animate">
											{updateErrors.merchant}
										</div>
									)}
									<Select
										classNamePrefix="react-select"
										name={`merchant`}
										placeholder="Merchant"
										value={merchants.filter(({ id }) => id === currentMerchant)}
										onChange={selection =>
											this.updateSelectedMerchant(selection, "merchant")
										}
										isClearable={false}
										getOptionLabel={({ title }) => title}
										getOptionValue={({ id }) => id}
										options={merchants}
									/>
								</div>

								<div className="form-field half-field">
									<button
										className={
											"btn btn--red btn--margin-top-float-right" +
											(currentMerchant === initialMerchant
												? " btn--hidden"
												: "")
										}
										disabled={currentMerchant === initialMerchant}
										onClick={() => this.submitMerchantChange()}
									>
										Change Merchant
									</button>
								</div>

								{/* MODAL */}
								{this.state.showModal && (
									<Modal
										title={"Merchant Change"}
										buttons={[
											{
												type: Button,
												text: "Close",
												action: () => this.setState({ showModal: false }),
												disabled: this.state.updateLoading
											},
											{
												type: Button,
												text: "Yes",
												action: () => this.handleMerchantUpdate(),
												disabled: this.state.updateLoading
											}
										]}
									>
										<div>
											{this.state.updateLoading ? (
												<div>
													Updating merchant type.
													<br />
													Please do not refresh the page.
													<div className="pt2 pb2">
														<Loader />
													</div>
												</div>
											) : (
												<div>
													{updateErrors.general ? (
														<div
															className="error msg_animate"
															dangerouslySetInnerHTML={{
																__html: sanitizeHtml(
																	updateErrors.general
																)
															}}
														/>
													) : (
														((
															<div class="instruction large-txt">
																<label>ATTENTION:</label>
																Are you sure you want to change your
																merchant?
																<br />
																This will clear all current merchant
																information for your cart!
															</div>
														),
														(
															<div>
																In order to ensure continued use of
																your cart, please have your user
																information ready before you do
																this.
																<br />
																This includes, username, api tokens,
																passwords for both sandbox and live
																usage!
															</div>
														))
													)}
												</div>
											)}
										</div>
									</Modal>
								)}
							</div>

							{merchantComponent}
						</div>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin,
		cart: state.siteInfo.site
	};
};

export default connect(
	mapStateToProps,
	{ addRoute, userTokenUpdate, setpageTitle, userLogout }
)(AdminMerchantSettings);



// WEBPACK FOOTER //
// ./src/components/admin/merchant/AdminMerchantSettings.js